import axios from 'axios';
import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';

export const facilityBrandingService = {
  /**
   * Get facility branding information by facility ID
   * @param {string} facilityId - The facility ID
   * @returns {Promise<Object>} Facility branding data
   */
  async getFacilityBranding(facilityId) {
    try {
      const token = await getAuthToken();
      const response = await axios.get(`${API_BASE}/facilities/${facilityId}/branding`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching facility branding:', error);
      throw error;
    }
  },

  /**
   * Update facility branding
   * @param {string} facilityId - The facility ID
   * @param {Object} brandingData - The branding data to update
   * @returns {Promise<Object>} Update result
   */
  async updateFacilityBranding(facilityId, brandingData) {
    try {
      const token = await getAuthToken();
      const response = await axios.put(`${API_BASE}/facilities/${facilityId}/branding`, brandingData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating facility branding:', error);
      throw error;
    }
  },

  /**
   * Get branding for multiple facilities
   * @param {Array<string>} facilityIds - Array of facility IDs
   * @returns {Promise<Array>} Array of facility branding data
   */
  async getMultipleFacilityBranding(facilityIds) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(`${API_BASE}/facilities/branding/batch`, { facilityIds }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching multiple facility branding:', error);
      throw error;
    }
  }
};
